/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetBranchShiftsSigmaResponse } from '../models/GetBranchShiftsSigmaResponse';
import type { PutBranchShiftsSigmaRequest } from '../models/PutBranchShiftsSigmaRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchShiftsService {
    /**
     * @returns GetBranchShiftsSigmaResponse OK
     * @throws ApiError
     */
    public static getBranchShiftsOperator({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<GetBranchShiftsSigmaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/branchshifts/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchShiftsOperator({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PutBranchShiftsSigmaRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/branchshifts/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchShifts`
     * @returns GetBranchShiftsSigmaResponse OK
     * @throws ApiError
     */
    public static getBranchShiftsAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<GetBranchShiftsSigmaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchshifts/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchShifts`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchShiftsAdmin({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PutBranchShiftsSigmaRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchshifts/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
